<template>
  <div class="Company_honor">
    <p class="title">公司荣誉</p>
    <img class="cup" :src="cup" />
    <img class="cup_iouticons" :src="cup_iouticons" />
    <img class="cup_text" :src="cup_text" />
  </div>
</template>

<script>
export default {
  name: 'CompanyHonor',
  data () {
    return {
      cup: require("@/assets/imgs/img-home-cup.png"),
      cup_iouticons: require("@/assets/imgs/img-home-cup-iouticons.png"),
      cup_text: require("@/assets/imgs/img-home-cup-text.png")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" type="text/scss">
  .Company_honor {
    width: 100%;
    height: 560px;
    position: relative;
    .title {
      height:50px;
      font-size:40px;
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(0,0,0,1);
      text-align: center;
      margin-top: 40px;
    }
    .cup {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
    }
    .cup_iouticons {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
    }
    .cup_text {
      position: absolute;
      left: 51.2%;
      top: 50%;
      transform: translate(-50%,-50%);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Home/CompanyHonor.vue